<div class="app-collections-wrapper" *ngIf="collectionService.collections">
  <app-collection *ngFor="let collection of collectionService.collections" [collection]="collection"></app-collection>
</div>

<mat-spinner *ngIf="loading"
            class="medium-centered-spinner" 
            [strokeWidth]="3" 
            [diameter]="40">
</mat-spinner>